import QuestionnaireForm from '../Common/QuestionnaireForm';
import * as Survey from "survey-react";
import * as Constants from '../Common/CommonConstants';

//const AUTO_SAVE_INTERVAL = 1000 * 60  * 5 //5 minutes
class QuestionnaireFormDirectLoad extends QuestionnaireForm {

    constructor( {match:{params:{jumpToPage}}}, ...props) {
        super(props);
        this.currentInstanceId = 0;
        this.jumpToPage = jumpToPage;
    }
   
    componentDidUpdate(prevProps) {
        if(this.props.directLoadedForm !== prevProps.directLoadedForm)
                this.populateDirectLoadedData();
    }

    populateDirectLoadedData = async () => {
        this.clearIntervalIfNecessary();
        this.setupFormState();
        //this.intervalId = setInterval(()=>this.performAutoSave(), AUTO_SAVE_INTERVAL);
    };

    setupFormState = () => {

        this.model = new Survey.Model(this.props.directLoadedForm.formInfo.form);

        // LW251103 CO#3865 Lock form in Optimus WTD Correspondence Manager
        var formName = this.props.directLoadedForm.formInfo.form.formName;
        //console.log("formName=" + formName);
        if (formName &&
            (formName.toLowerCase().indexOf(Constants.FormName_MemberShip) > -1 ||
            formName.toLowerCase().indexOf(Constants.FormName_Ownership) > -1 ||
            formName.toLowerCase().indexOf(Constants.FormName_VFEF) > -1)) {
            this.model.showCompleteButton = false;
            //this.model.showNavigationButtons = false;
            this.model.readOnly = true;
            this.model.mode = "display"
        }

        if(this.jumpToPage > 1 && this.model.pageCount > 1 ){
            var newPage = this.model.pages[this.jumpToPage-1];
            this.model.currentPage = newPage;
        }
            

        if(this.props.completeButtonText)
            this.model.completeText =  this.props.completeButtonText;
                
        this.setFormData(this.props.directLoadedForm.formInfo);
        this.currentInstanceId = this.props.directLoadedForm.instanceId;
                        
        this.setState({ loading: false, isComplete: false });
    }
}
export default QuestionnaireFormDirectLoad;